import React from "react";
import { Modal, notification } from "antd";
import GistEditorForm from "../../shared/components/GistEditorForm";

const modalStyles = {
  mask: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    backdropFilter: 'blur(4px)',
  },
  content: {
    borderRadius: 8,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    border: '1px solid var(--color-border)',
  },
};

const CreateGistModal: React.FC<{
  visible: boolean;
  onClose: () => void;
  subjectId: number | undefined;
}> = ({ visible, onClose, subjectId }) => {

  const handleSuccess = () => {
    notification.success({
      message: "Success!",
      description: "Gist created successfully!",
    });
    onClose();
  };

  if (!subjectId) return null;

  return (
    <Modal
      title={<span style={{ color: 'var(--color-forest)', fontWeight: 600 }}>📝 Create New Gist</span>}
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={520}
      maskStyle={modalStyles.mask}
      styles={{ content: modalStyles.content }}
      destroyOnClose
    >
      <GistEditorForm
        subjectId={subjectId}
        onSuccess={handleSuccess}
        onCancel={onClose}
      />
    </Modal>
  );
};

export default CreateGistModal;
